/**
 * JWT token storage using sessionStorage.
 *
 * sessionStorage survives page reloads within the same tab but is cleared
 * when the tab/browser closes. This balances usability (no re-login on
 * refresh) with security (tokens not persisted across sessions).
 */
const TOKEN_KEY = "cg_token";

/**
 * Retrieves the current JWT token.
 *
 * Returns:
 *   The current token string, or null if not authenticated.
 */
export function getToken(): string | null {
  return sessionStorage.getItem(TOKEN_KEY);
}

/**
 * Stores a JWT token in sessionStorage.
 *
 * Args:
 *   token: The JWT token string to store.
 */
export function setToken(token: string): void {
  sessionStorage.setItem(TOKEN_KEY, token);
}

/**
 * Clears the JWT token (logout).
 */
export function clearToken(): void {
  sessionStorage.removeItem(TOKEN_KEY);
}
